import { useMemo } from "react";
import { useBalance } from "wagmi";
import { PAY_TOKENS_FILTERED } from "../../../constants/paymentTokens";

// 自定义 Hook 来获取和格式化余额
export const useFormattedTokens = (address: string | undefined) => {
	const balanceQueries = PAY_TOKENS_FILTERED.flatMap((token) =>
		token.chains.map((chain) => ({
			token,
			chain,
			balance: useBalance({
				address: address as `0x${string}` | undefined,
				token: chain.address as `0x${string}`,
				chainId: chain.chainId,
			}),
		})),
	);

	return useMemo(() => {
		if (!address) return [];

		const balanceMap = Object.fromEntries(
			balanceQueries.map(({ token, chain, balance }) => [
				`${token.symbol}_${chain.chainId}`,
				{
					balance: balance.data?.value || "0",
					decimals: balance.data?.decimals || 18,
				},
			]),
		);

		return PAY_TOKENS_FILTERED.map((token) => ({
			...token,
			chains: token.chains
				.map((chain) => {
					const key = `${token.symbol}_${chain.chainId}`;
					const balanceInfo = balanceMap[key] || { balance: "0", decimals: 18 };
					return { ...chain, ...balanceInfo };
				})
				.sort((a, b) => Number(b.balance) - Number(a.balance)),
		}));
	}, [address, balanceQueries]);
};
